import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { AppSessionService } from "../app-session/app-session.service";

import { SiteGroupDTO } from "src/app/models/Sites/siteGroupDTO";
import { setAdvancedFilterQuery, setSimpleFilterQuery } from "../../utils/tableUtils";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import { GridUtils } from "../../utils/gridUtils";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class SiteGroupsService {
  constructor(
    private http: HttpClient,
    private appSession: AppSessionService
  ) {}
    
  private SITE_GROUPS_URL = this.appSession.baseUrl + "/api/v1/siteGroups";

  getSiteGroup(token: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.SITE_GROUPS_URL}/${token}`;
    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  getSiteGroupsList(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    const url = paging
      ? this.buildDataUrl(paging, "/search?")
      : `${this.SITE_GROUPS_URL}/search?`;

    return this.http.get<any>(url, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  createSiteGroup(siteGroup: SiteGroupDTO): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(siteGroup);
    const url = `${this.SITE_GROUPS_URL}`;
    return this.http.post<any>(url, data, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  updateSiteGroup(siteGroup: SiteGroupDTO, token: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const data = JSON.stringify(siteGroup);
    const url = `${this.SITE_GROUPS_URL}/${token}`;
    return this.http.put<any>(url, data, { headers }).pipe(
      map(({ result }) => result),
      catchError((error) => throwError(error))
    );
  }

  // Grid filter helpers block
  private buildDataUrl(pagingArgs: any, path: string): string {
    let baseQueryString = `${this.SITE_GROUPS_URL}${path}`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = GridUtils._buildScrollExpression(pagingArgs);
    }

    query += scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;
    baseQueryString += query;

    return baseQueryString;
  }
}
